module.exports = __webpack_public_path__ + "media/images/svg/facebook-378bd549f0bc5a64b563cf343a8b9195.svg";